<svg width="48" height="28" viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="48" height="28" rx="4" fill="#FFFFFF" />
  <g transform="translate(10, 6)">
    <rect x="0" y="0" width="8.5" height="16" rx="2" fill="#003B82" />
    <rect x="9.5" y="0" width="8.5" height="16" rx="2" fill="#CE1126" />
    <rect x="19" y="0" width="8.5" height="16" rx="2" fill="#008238" />
    <text x="4.25" y="11" fill="#FFFFFF" font-size="6.5" font-weight="900" font-family="sans-serif" text-anchor="middle">J</text>
    <text x="13.75" y="11" fill="#FFFFFF" font-size="6.5" font-weight="900" font-family="sans-serif" text-anchor="middle">C</text>
    <text x="23.25" y="11" fill="#FFFFFF" font-size="6.5" font-weight="900" font-family="sans-serif" text-anchor="middle">B</text>
  </g>
</svg>
